import { render, staticRenderFns } from "./TableSets.vue?vue&type=template&id=1f39985a&"
import script from "./TableSets.vue?vue&type=script&lang=js&"
export * from "./TableSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports